import React, { useState } from "react";
import { AdminDashboard } from "../Components/AdminDashboard";
import { AdminLogs } from "../Components/AdminLogs";
import { ContactFormsList } from "../Components/ContactFormsList";
import { UsersList } from "../Components/UsersList"; // Import the new component

type TabType = "dashboard" | "contacts" | "logs" | "users"; // Add users to tab types

export default function Admin() {
  const [activeTab, setActiveTab] = useState<TabType>("dashboard");

  return (
    <div className="min-h-full h-full p-8 dark:bg-neutral-dark text-gray-900 dark:text-gray-100">
      <h1 className="text-3xl font-bold mb-6">Admin Panel</h1>

      <div className="border-b border-gray-200 dark:border-gray-700 mb-8">
        <nav className="-mb-px flex space-x-8">
          <button
            onClick={() => setActiveTab("dashboard")}
            className={`
              py-4 px-1 border-b-2 font-medium text-sm transition-colors duration-150
              ${activeTab === "dashboard"
                ? "border-indigo-500 text-indigo-600 dark:text-indigo-400"
                : "border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 hover:border-gray-300 dark:hover:border-gray-600"}
            `}
          >
            Dashboard
          </button>
          <button
            onClick={() => setActiveTab("contacts")}
            className={`
              py-4 px-1 border-b-2 font-medium text-sm transition-colors duration-150
              ${activeTab === "contacts"
                ? "border-indigo-500 text-indigo-600 dark:text-indigo-400"
                : "border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 hover:border-gray-300 dark:hover:border-gray-600"}
            `}
          >
            Contact Forms
          </button>
          <button
            onClick={() => setActiveTab("logs")}
            className={`
              py-4 px-1 border-b-2 font-medium text-sm transition-colors duration-150
              ${activeTab === "logs"
                ? "border-indigo-500 text-indigo-600 dark:text-indigo-400"
                : "border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 hover:border-gray-300 dark:hover:border-gray-600"}
            `}
          >
            System Logs
          </button>
          {/* Add new Users tab */}
          <button
            onClick={() => setActiveTab("users")}
            className={`
              py-4 px-1 border-b-2 font-medium text-sm transition-colors duration-150
              ${activeTab === "users"
                ? "border-indigo-500 text-indigo-600 dark:text-indigo-400"
                : "border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 hover:border-gray-300 dark:hover:border-gray-600"}
            `}
          >
            Users
          </button>
        </nav>
      </div>

      <div className="bg-white dark:bg-neutral-dark rounded-lg shadow">
        {activeTab === "dashboard" && <AdminDashboard />}
        {activeTab === "contacts" && <ContactFormsList />}
        {activeTab === "logs" && <AdminLogs />}
        {activeTab === "users" && <UsersList />} {/* Add the UsersList component */}
      </div>
    </div>
  );
}
